import React from 'react';
import { UNIT_STATUS_LABELS, UNIT_STATUS_REASONS, UNIT_STATUS_PRESUMED, UNIT_STATUS_PRESUMED_HINT, stoppedBy } from '../config/unitStatusLabels';
import '../styles/UnitStatusPanel.css';

/**
 * The compact «حالة التشغيل» — one word in the status colour, for lists and side panels
 * (properties list, inbox). The unit page uses the full strip (UnitStatusPanel).
 *
 * Staff only: the five statuses (reason in the tooltip, «حسب الموعد» when based on the schedule, not
 * observed). Owners see the owner pages, whose status words live in ownerApp.unitStatus (owner app 8c).
 * `null` renders nothing — a list row whose status did not load stays quiet rather than guessing.
 */
const TONE = {
  OCCUPIED: 'occupied', STOPPED: 'stopped', AWAITING_CLEANING: 'waiting', UNKNOWN: 'unknown',
  READY: 'ready', PREPARING: 'waiting', AVAILABLE: 'ready',
};

const UnitStatusChip = ({ unitStatus, showReason = false }) => {
  if (!unitStatus?.status) return null;
  const label = UNIT_STATUS_LABELS[unitStatus.status] || unitStatus.status;
  const reason = unitStatus.reasonCode === 'UNIT_STOPPED' && unitStatus.stoppedByName
    ? stoppedBy(unitStatus.stoppedByName)
    : UNIT_STATUS_REASONS[unitStatus.reasonCode];
  const presumed = unitStatus.confidence === 'PRESUMED';
  return (
    <span className={`unit-status-chip tone-${TONE[unitStatus.status] || 'unknown'}`} title={reason || undefined}>
      <span className="unit-status-chip-dot" aria-hidden="true"></span>
      {label}
      {presumed && <span className="unit-status-chip-presumed" title={UNIT_STATUS_PRESUMED_HINT}>{UNIT_STATUS_PRESUMED}</span>}
      {showReason && reason && <span className="unit-status-chip-reason">— {reason}</span>}
    </span>
  );
};

export default UnitStatusChip;
